import styled from 'styled-components';
import { CaptionBoldL, CaptionRegularL } from '../../styles/globals';
import { ITheme } from '../../styles/theme';

interface IResponseRateCont {
  theme: ITheme;
  background: string;
  borderColor: string
}

export const ResponseRateCont = styled.div<IResponseRateCont>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${({ theme, background, borderColor }: IResponseRateCont) => `
      background: ${background};
      border: 1px solid ${borderColor};
      border-radius: ${theme.layout.spacing.nano};
      padding: ${theme.layout.spacing.nano} ${theme.layout.spacing.mikro};
      height: ${theme.typography.sizes.decy};
  `}
`;

interface IPercentCont {
  theme: ITheme;
  color: string
}

export const PercentCont = styled(CaptionBoldL)<IPercentCont>`
  ${({ theme, color }: IPercentCont) => `
      color: ${color};
      margin-right: ${theme.layout.spacing.nano};
  `}
`;

export const ScaleCont = styled(CaptionRegularL)``;